import React from "react";
import { Container } from "react-bootstrap";
const Settings = () => <Container className="p-3">Settings</Container>;
export default Settings;
